import { persistentAtom } from '@nanostores/persistent'

export const optionsData = persistentAtom(
    'productOptions',
    {},
    {
        encode(optionsObj) {
            return JSON.stringify(optionsObj)
        },
        decode(optionsObj) {
            return JSON.parse(optionsObj)
        },
    }
)
